import React, { useState } from 'react';
import { Markup } from 'interweave';
import { FaqEntry } from '../api/model/FaqEntry';
import { ChevronRight } from '../components/icons';

type HelpDeskEntryProps = {
  element: FaqEntry;
  index: number;
};

function HelpDeskEntry({ element, index }: HelpDeskEntryProps) {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`payroll-faq-item${open ? ' is-open' : ''}`}
      style={{ ['--payroll-faq-delay' as string]: `${0.3 + index * 0.04}s` }}
    >
      <button
        type="button"
        className="payroll-faq-item__header"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="payroll-faq-item__question">{element.question}</span>
        <span className={`payroll-faq-item__chevron${open ? ' is-open' : ''}`} aria-hidden="true">
          <ChevronRight color="currentColor" />
        </span>
      </button>
      {open ? (
        <div className="payroll-faq-item__answer">
          <Markup content={element.answer} />
        </div>
      ) : null}
    </div>
  );
}

export default HelpDeskEntry;
